import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import TermsAndConditions from '../landing/TermsAndConditions';
import { closeModal } from '../../actions/modalAction';

const actions = { closeModal };

class TermsAndConditionsModal extends Component {
  render() {
    return (
      <Modal size="small" 
      open={true} onClose={this.props.closeModal}
      style={{maxWidth:'700px'}}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      >
       
        <Modal.Content className='border'  style={{maxWidth:'700px',padding:'10px'}}>
           <Modal.Description>
            <TermsAndConditions />
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(TermsAndConditionsModal);
